var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_35_90",
    "data-name": "Component 35 \\u2013 90",
    xmlns: "http://www.w3.org/2000/svg",
    width: 926.745,
    height: 761.944,
    viewBox: "0 0 926.745 761.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_108",
    "data-name": "Group 108",
    transform: "translate(-1227.726 -187.287)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(1434.502 462.477)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_118",
    "data-name": "Ellipse 118",
    cx: 172.372,
    cy: 22.186,
    rx: 172.372,
    ry: 22.186,
    transform: "translate(-53.775 347.381)",
    fill: "#1fa085",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_280",
    "data-name": "Path 280",
    d: "M752.57,774.9,746.31,677l-.13-.21-6.32,2.2L710.77,763.8,664.52,731l73.69-53.41.07-.21.42-.15,4.75-3.45-77.24-43.31-18.93,20.8,3,19.5,88.8,1.58v2l-90.48-1.62-3.4-22.11,25.89-28.45L709.81,577l.69,1.87,8.2-9,30.54,5.47v-1.21l2,.06v1.51l45.36,8.12-42.33,84.65-6.17,4.47V674l97.81-34.08L834.3,731.13l-83-52.87-2.92-1.64,48.94,78.89Zm-4-94.34,5.85,91.38,40.05-17.38ZM668,731l41.79,29.63,27.34-79.74Zm82.32-55.66,2.09,1.17,80.35,51.2,10.8-84.87Zm-7.1-7.2,2.51,4.05.44-.32,3-94.53L719.43,572l-8.16,9Zm-75.39-39.05,74.84,42-1.3-2.13-31.58-86.27-37.2,40.88ZM751.2,577.7l-3,92.69,4.52-3.28,40.91-81.82Z",
    transform: "translate(-203.645 -421.985)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_281",
    "data-name": "Path 281",
    d: "M326.38,774.5l-6.27-97.94-.13-.21-6.32,2.2L284.58,763.4l-46.25-32.79L312,677.2l.07-.21.42-.15,4.75-3.45L240,630.08l-18.92,20.8,3,19.5L312.9,672v2l-90.48-1.62L219,650.24l25.9-28.46,38.75-45.2.69,1.87,8.2-9L323,574.91V573.7l2,.06v1.51l45.36,8.12L328.07,668l-6.17,4.47v1.06l97.8-34.08-11.61,91.21-83-52.87-2.92-1.64,48.94,78.88Zm-4-94.34,5.85,91.38,40.05-17.38ZM241.8,730.59l41.79,29.63,27.34-79.74Zm82.32-55.66,2.09,1.17,80.35,51.2,10.8-84.87Zm-7.1-7.2,2.51,4.05.44-.32,3-94.53-29.74-5.32-8.16,9ZM241.6,628.67l74.84,42-1.3-2.13-31.58-86.27-37.19,40.87ZM325,577.28,322,670l4.52-3.28,40.91-81.82Z",
    transform: "translate(-203.645 -421.985)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_289",
    "data-name": "Path 289",
    d: "M747.48,556.12a117.49,117.49,0,0,0-31.41,4.24,115.568,115.568,0,0,0-15.46,5.47,117.7,117.7,0,1,0,46.86-9.71Zm-.4,206.09a88.86,88.86,0,0,1-36.9-169.68,87.773,87.773,0,0,1,14.56-5.17,88.85,88.85,0,1,1,22.35,174.85Z",
    transform: "translate(-203.645 -421.985)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_290",
    "data-name": "Path 290",
    d: "M559.39,422.46s117.65-4,120.05,11.21-117.65,8.8-117.65,8.8S552.19,432.86,559.39,422.46Z",
    transform: "translate(-203.645 -421.985)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_291",
    "data-name": "Path 291",
    d: "M559.39,422.46s117.65-4,120.05,11.21-117.65,8.8-117.65,8.8S552.19,432.86,559.39,422.46Z",
    transform: "translate(-203.645 -421.985)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_111",
    "data-name": "Ellipse 111",
    transform: "translate(277.315 324.625)",
    fill: "none",
    stroke: "#c1272d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 20.81,
    height: 180.88,
    transform: "translate(239.695 61.305)",
    fill: "#1fa085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_292",
    "data-name": "Path 292",
    d: "M464.15,483.28v13.93c-6.92.9-14,1.47-20.81,1.69V483.28Z",
    transform: "translate(-203.645 -421.985)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_293",
    "data-name": "Path 293",
    d: "M454.3,464.86c-24.412-3.8-40.129-4.43-47.779,3.26-9.6,9.6-6.4,26.41,19.21,28.81s78.375-1.863,78.44-13.61S478.711,468.66,454.3,464.86Z",
    transform: "translate(-203.645 -421.985)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_294",
    "data-name": "Path 294",
    d: "M387.4,475.4l218.5-68.03,7.2,16.81L389,501.01Z",
    transform: "translate(-132.495 -364.475)",
    fill: "#1fa085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_295",
    "data-name": "Path 295",
    d: "M452.23,582.65,609.9,427.38l8.8,12.8L468.23,597.05Z",
    transform: "translate(-132.495 -364.475)",
    fill: "#1fa085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_296",
    "data-name": "Path 296",
    d: "M724.73,587.36a87.774,87.774,0,0,0-14.56,5.17l-9.56-26.71a115.55,115.55,0,0,1,15.46-5.47Z",
    transform: "translate(-203.645 -421.985)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    d: "M680.33,608.26l-11.2,6.4L590.99,396.33l-3.5-9.77,18.41-10.41,4.61,14.38Z",
    transform: "translate(-132.495 -364.475)",
    fill: "#1fa085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    d: "M610.51,390.53l-19.52,5.8-3.5-9.77,18.41-10.41Z",
    transform: "translate(-132.495 -364.475)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_299",
    "data-name": "Path 299",
    d: "M562.59,464.88l109.65-37.62s19.21,2.4,12,18.41L573.8,478.48S557,480.08,562.59,464.88Z",
    transform: "translate(-203.645 -421.985)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_300",
    "data-name": "Path 300",
    d: "M436.07,647.46a117.22,117.22,0,0,0-23.71-48.58,117.885,117.885,0,1,0,26.58,74.49,117.568,117.568,0,0,0-2.87-25.91ZM320.88,761.81A88.75,88.75,0,1,1,408.28,689a88.75,88.75,0,0,1-87.4,72.81Z",
    transform: "translate(-203.645 -421.985)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M438.94,673.37a119.073,119.073,0,0,1-1.417,18.3C427.92,691,418,690,408.28,689a89.59,89.59,0,0,0-.79-35.88c9.47-2,19.14-3.91,28.58-5.64a117.568,117.568,0,0,1,2.87,25.89Z",
    transform: "translate(-203.645 -421.985)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_302",
    "data-name": "Path 302",
    d: "M464.15,642.89v21.27H443.34v-18C450.54,644.91,457.54,643.8,464.15,642.89Z",
    transform: "translate(-203.645 -421.985)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_303",
    "data-name": "Path 303",
    d: "M329.69,673s168.08-44,181.68-27.21S539.38,685,497,693s-170.48-13.61-170.48-13.61Z",
    transform: "translate(-203.645 -421.985)",
    fill: "#1fa085"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_304",
    "data-name": "Path 304",
    d: "M412.36,598.88,391,618.43a89,89,0,0,0-12.76-13.28l19.94-20.83a118.769,118.769,0,0,1,14.18,14.56Z",
    transform: "translate(-203.645 -421.985)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_305",
    "data-name": "Path 305",
    d: "M252.94,606.66,378.59,475.4l4.01,30.41L259.34,618.66Z",
    transform: "translate(-132.495 -364.475)",
    fill: "#1fa085"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_112",
    "data-name": "Ellipse 112",
    cx: 12.81,
    cy: 12.81,
    rx: 12.81,
    ry: 12.81,
    transform: "translate(106.035 238.175)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_113",
    "data-name": "Ellipse 113",
    cx: 12.81,
    cy: 12.81,
    rx: 12.81,
    ry: 12.81,
    transform: "translate(104.425 238.175)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_114",
    "data-name": "Ellipse 114",
    cx: 12.81,
    cy: 12.81,
    rx: 12.81,
    ry: 12.81,
    transform: "translate(529.825 236.975)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_115",
    "data-name": "Ellipse 115",
    cx: 12.81,
    cy: 12.81,
    rx: 12.81,
    ry: 12.81,
    transform: "translate(530.625 238.575)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 25.61,
    cy: 25.61,
    rx: 25.61,
    ry: 25.61,
    transform: "translate(290.115 212.575)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_117",
    "data-name": "Ellipse 117",
    cx: 25.61,
    cy: 25.61,
    rx: 25.61,
    ry: 25.61,
    transform: "translate(291.725 212.575)",
    fill: "#535461"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 13.61,
    height: 47.54,
    rx: 6.8,
    transform: "translate(305.043 240.344) rotate(-36.79)",
    fill: "#1fa085"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 60,
    height: 19,
    transform: "translate(290.485 266.015)",
    fill: "#1fa085"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 60,
    height: 19,
    transform: "translate(290.485 266.015)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_119",
    "data-name": "Ellipse 119",
    cx: 172.372,
    cy: 22.186,
    rx: 172.372,
    ry: 22.186,
    transform: "translate(375.225 347.381)",
    fill: "#1fa085",
    opacity: 0.1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    transform: "translate(-707.991)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_103",
    "data-name": "Ellipse 103",
    cx: 172.372,
    cy: 22.186,
    rx: 172.372,
    ry: 22.186,
    transform: "translate(707.991 717.571)",
    fill: "#1fa085",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_216",
    "data-name": "Path 216",
    d: "M949.537,294.753l-6.923,46.069L863.5,394.335s-41.6,19.934-38.979,32.319c2.334,11.04,34.434,9.733,44.535-7.338l94.591-43,31.635-62.629Z",
    transform: "translate(-99.574 -107.421)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_217",
    "data-name": "Path 217",
    d: "M806.5,558.589,810,607.6l33.838-2.334L838,558.589Z",
    transform: "translate(43.878 93.193)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_218",
    "data-name": "Path 218",
    d: "M950.1,724.138s-4.667-17.5-9.335-16.336l-7,12.835s-31.5,29.171-40.839,30.338c0,0-30.338,9.335,0,23.337h35.005s23.337-1.167,28,0,31.5,1.167,32.671-5.834-3.5-21-3.5-21-4.3-34.425-9.152-27.714a91.633,91.633,0,0,1-8.35,10.211Z",
    transform: "translate(-90.39 -38.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_219",
    "data-name": "Path 219",
    d: "M881.5,559.089,885,608.1l33.838-2.334L913,559.089Z",
    transform: "translate(56.391 93.276)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_220",
    "data-name": "Path 220",
    d: "M1025.1,724.638s-4.667-17.5-9.335-16.336l-7,12.835s-31.5,29.171-40.839,30.338c0,0-30.338,9.335,0,23.337h35.005s23.337-2.334,28-1.167,31.5,1.167,32.671-5.834-3.5-19.836-3.5-19.836-4.3-34.425-9.153-27.714a91.641,91.641,0,0,1-8.35,10.211Z",
    transform: "translate(-77.877 -38.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M893.834,435.665,888,443.833v16.336l37.339,138.854,7,30.338s0,116.684,7,116.684,38.506,3.5,38.506-3.5-2.334-165.691-2.334-165.691l31.5,59.509s14,105.015,18.669,106.182,37.339,0,39.672-7l-7-66.51s1.167-74.678-18.669-91.013c0,0-3.5-19.836-7-28s-9.335-12.835-5.834-18.669-4.668-70.01-4.668-70.01,2.334-19.836-2.334-25.67S893.834,435.665,893.834,435.665Z",
    transform: "translate(-88.963 -84.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_102",
    "data-name": "Ellipse 102",
    cx: 36.172,
    cy: 36.172,
    r: 36.172,
    transform: "translate(843.377 14.106)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M984.008,196.462,981.674,219.8l9.335,8.168-59.509,28c14.659-25.044,19-47.849,11.668-64.176Z",
    transform: "translate(-81.706 -124.598)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M950.342,227.463s-9.335,18.669,2.334,14l36.172-25.67s39.672,15.169,53.674,32.671L1030.854,372.15l-9.335,87.513s5.834,10.5,4.667,11.668-2.334-1.167-1.167,2.334,4.667,0,1.167,3.5-7,0-3.5,3.5,0,4.667,0,4.667-4.667-28-45.507-7S918.838,505.17,888.5,479.5L923.505,346.48l2.826-50.17a206.662,206.662,0,0,1,8.88-49.374c2.676-8.662,7.338-17.174,15.13-21.807Z",
    transform: "translate(-88.879 -120.594)",
    fill: "#ff7a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M999.112,314.3l17.5,43.173-40.839,86.346s-9.335,10.5-3.5,23.337a154.213,154.213,0,0,0,10.5,19.836s10.5-4.667,10.5-24.5l59.509-85.179-4.667-70.01Z",
    transform: "translate(-75.223 -105.328)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M994.584,248.139s-16.336,16.336-9.335,42.006,12.835,45.507,12.835,45.507,28-21,51.341-8.168c0,0-3.5-75.844-23.337-82.845S994.584,248.139,994.584,248.139Z",
    transform: "translate(-73.029 -116.183)",
    fill: "#ff7a5a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M992.01,153.453s-11.052-23.945-32.234-18.419-33.155,13.815-34.076,22.1.461,20.722.461,20.722,2.3-17.038,17.038-13.354,37.76.921,37.76.921l3.684,33.155s6.282-6.7,10.887-3.012S1006.746,160.821,992.01,153.453Z",
    transform: "translate(-82.726 -134.206)",
    fill: "#ffb85f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M825.982,374.447h0l21.536-4.988A4.7,4.7,0,0,1,852.811,372l22.061,45.747a3.8,3.8,0,0,1-2.383,5.3L850.6,429.265a5.018,5.018,0,0,1-5.98-2.843l-14.076-32.7-.429.238-2.679-6.194.445-.228-3.929-9.127a2.893,2.893,0,0,1,2.028-3.968Z",
    transform: "translate(-99.687 -94.977)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M844.6,370.992l2.514-.582a3.247,3.247,0,0,1,3.668,1.774l21.533,45.454a2.012,2.012,0,0,1-1.237,2.788l-21.733,6.557a2.606,2.606,0,0,1-3.147-1.466L825.827,378.1a2.283,2.283,0,0,1,1.582-3.125l2.385-.552a1.077,1.077,0,0,1,1.193.542h0a.951.951,0,0,0,1.054.478l11.322-2.622a1.626,1.626,0,0,0,1.24-1.828Z",
    transform: "translate(-99.367 -94.812)",
    fill: "#1fa085"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoy);
export default __webpack_public_path__ + "static/media/boy.28f4f128f4f644aa492ab1e4088eb89b.svg";
export { ForwardRef as ReactComponent };